import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';

import Button from '~/components/core/Atomic/Buttons/Button';

import CreateSnapshotDialog from './CreateSnapshotDialog';

interface CreateSnapshotContainerProps {
  className?: string;
  onSuccess: () => void;
}

const CreateSnapshotContainer: React.FC<CreateSnapshotContainerProps> = ({ className, onSuccess }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button className={className} onClick={() => setIsDialogOpen(true)} startIcon={<AddIcon />}>
        Create New Snapshot
      </Button>
      {isDialogOpen && (
        <CreateSnapshotDialog
          onClose={() => setIsDialogOpen(false)}
          onSuccess={() => {
            setIsDialogOpen(false);
            onSuccess();
          }}
        />
      )}
    </>
  );
};

export default CreateSnapshotContainer;
